import Marionette from "../../shared/marionette-mustache";
import { backboneViewProperties } from "../../decorators/backbone-properties";
import * as Backbone from "backbone-associations";
import { autoinject, transient } from "aurelia-dependency-injection";

const template = require<string>("../../desktop/views/document-error.html");

@backboneViewProperties({
    template
})
@autoinject
@transient()
export class DocumentErrorView extends Marionette.ItemView<Backbone.Model> {
    constructor(options: any) {
        super(options);
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/desktop/views/document-error.ts